import { API, graphqlOperation } from "aws-amplify";
import handleError from "../../errorHandler";
import { GET_SKILLS_PROGRESS, GET_SKILLS_PROGRESS_SUCCESS, GET_SKILLS_PROGRESS_FAILURE, TRIGGER_TOAST } from "../constants";
import { GetSkillsProgress } from "./../../queries";

const getSkillsProgress = (userId: string) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_SKILLS_PROGRESS });
    if(!!sessionStorage.getItem("isDemoUser")) {
      const dummyData = require("../../data/MockData/getSkillsReport.json");
      dispatch({ type: GET_SKILLS_PROGRESS_SUCCESS, payload: { ...dummyData } });
    } else {    
      const skillsProgressResp = API.graphql(graphqlOperation(GetSkillsProgress, { userId })) as any;
      skillsProgressResp.then(async (skillsProgressData: any) => {
        if (skillsProgressData && skillsProgressData.data) {
          dispatch({ type: GET_SKILLS_PROGRESS_SUCCESS, payload: { ...skillsProgressData } });
        } else {
          dispatch({ type: GET_SKILLS_PROGRESS_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity : 'error',
              transMessage: "message_errorDefault"
            },
          });
        }
      }).catch((err: any) => {
        dispatch({ type: GET_SKILLS_PROGRESS_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity : 'error',
            transMessage: "message_errorDefault"
          },
        });
      });
    }
  };
};

export default {
  getSkillsProgress,
};
